import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContestQuestionDialog from "src/components/contest-admin/ContestQuestionDialog";
import { getUserPermissions } from "src/utils/permissionsUtils";

import { createBlobInContainer } from "src/utils/azureBlob";
import moment from "moment";
import { get, post, put } from "src/utils/networkUtils";
import ContestFormFields from "src/components/mini-games/ContestFormFields";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
export default function MinigamesContestEditPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState(null);
  const [openStageDialog, setOpenStageDialog] = useState(false);
  const [searchParams] = useSearchParams();
  const [editQuestion, setEditQuestion] = useState(null);
  const [contestId, setContestId] = useState(null);
  const [contest, setContest] = useState(null);
  const { isViewer } = getUserPermissions();

  useEffect(() => {
    if (searchParams.has("contest_id")) {
      let contestId = searchParams.get("contest_id");
      setContestId(contestId);
      get(`/admin/minigames/contests/${contestId}`).then(function (response) {
        setRows(response.contest.questions);
        setContest(response.contest);
      });
    }
  }, [searchParams]);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const handleCloseStageDialog = () => {
    setEditQuestion(null);
    setOpenStageDialog(false);
  };
  const handleOpenEditQuestionDialog = (questionId) => {
    const question = rows.find((item) => item.questionId === questionId);
    console.log(question, questionId);
    if (question) {
      setEditQuestion(question);
      setOpenStageDialog(true);
      setOpen(null);
      setOpenId(null);
    }
  };
  const handleSuccessStageDialog = () => {
    window.location.reload(true);
  };
  const handleAnswerChange = (event, questionId) => {
    const index = rows.findIndex((item) => item.questionId === questionId);
    if (index !== -1) {
      rows[index].answer = event.target.value;
      setRows([...rows]);
    }
  };
  const updateAnswersHandler = () => {
    setLoading(true);
    const answers = rows.map((item) => {
      return { questionId: item.questionId, answer: item.answer };
    });
    put(`/admin/minigames/contests/${contestId}/questions-answers`, {
      answers,
    }).then(function (response) {
      window.location.reload(true);
    });
  };
  const updateContestHandler = () => {
    setLoading(true);
    put(`/admin/minigames/contests/${contestId}`, contest).then(function (
      response
    ) {
      window.location.reload(true);
    });
  };
  const payPrizesHandler = (questionId) => {
    setLoading(true);
    setOpen(null);
    setOpenId(null);
    post(
      `/admin/minigames/contests/${contestId}/questions/${questionId}/pay-prizes`
    ).then(function (response) {
      window.location.reload(true);
    });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setContest((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const uploadFiles = (event, name) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;

      let uploadPromises = [];
      uploadPromises.push(createBlobInContainer(files[0]));

      if (uploadPromises.length > 0) {
        const uploadFiles = async () => {
          await Promise.all(uploadPromises);

          const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
          const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
          setContest((prevState) => ({
            ...prevState,
            [name]: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${files[0].name}`,
          }));
        };

        uploadFiles().catch(console.error);
      }
    }
  };
  const handleDateChange = (newValue, fieldName) => {
    setContest((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).format(dateFormat),
    }));
  };
  return (
    <>
      <Helmet>
        <title> Contest </title>
      </Helmet>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Typography variant="h4" gutterBottom>
          Contest
        </Typography>
        <Box>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={() => updateContestHandler()}
            sx={{ mr: 2 }}
          >
            Save
          </Button>
        </Box>
      </Stack>
      <Container>
        <Card sx={{ p: 2, mb: 3 }}>
          {contest === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <ContestFormFields
              contest={contest}
              handleChange={handleChange}
              handleDateChange={handleDateChange}
              uploadFiles={uploadFiles}
            />
          )}
        </Card>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Questions
          </Typography>
          <Box>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:save-outline" />}
              onClick={() => updateAnswersHandler(true)}
              sx={{ mr: 2 }}
            >
              Save Answers
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-outline" />}
              onClick={() => setOpenStageDialog(true)}
            >
              Add Question
            </Button>
          </Box>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>Paid</TableCell>
                      <TableCell>Answer</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.questionId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Box>{row.scoreable?.displayName}</Box>
                          <Box>
                            {row.targetValue} {row.text}
                          </Box>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.startDate}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.endDate}
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {row.isPrizesPaid ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <FormControlLabel
                            value="0"
                            control={<Radio />}
                            label="None"
                            labelPlacement="bottom"
                            checked={row.answer === 0}
                            onChange={(event) =>
                              handleAnswerChange(event, row.questionId)
                            }
                          />
                          <FormControlLabel
                            value="1"
                            control={<Radio />}
                            label="Over"
                            labelPlacement="bottom"
                            checked={row.answer === 1}
                            onChange={(event) =>
                              handleAnswerChange(event, row.questionId)
                            }
                          />
                          <FormControlLabel
                            value="2"
                            control={<Radio />}
                            label="Under"
                            labelPlacement="bottom"
                            checked={row.answer === 2}
                            onChange={(event) =>
                              handleAnswerChange(event, row.questionId)
                            }
                          />
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.questionId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        {!isViewer && (
          <MenuItem onClick={() => handleOpenEditQuestionDialog(openId)}>
            <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
            Edit
          </MenuItem>
        )}

        <MenuItem onClick={() => payPrizesHandler(openId)}>
          <Iconify icon={"eva:behance-outline"} sx={{ mr: 2 }} />
          Pay Prizes
        </MenuItem>
        {!isViewer && (
          <MenuItem
            onClick={() =>
              navigate(`/dashboard/stage/leaderboard?stage_id=${openId}`)
            }
          >
            <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
            Delete
          </MenuItem>
        )}
      </Popover>

      {openStageDialog && (
        <ContestQuestionDialog
          contestId={contestId}
          question={editQuestion}
          open={openStageDialog}
          onSuccessHandler={handleSuccessStageDialog}
          onClose={handleCloseStageDialog}
        />
      )}
    </>
  );
}
